export const getLeadCardStatusString = (status: string) => {
    switch (status) {
        case 'OPEN':
        case 'open':
            return 'Open';
        case 'LOST':
        case 'lost':
            return 'Lost';
        case 'WON':
        case 'won':
            return 'Won';
        case 'CANCELLED':
        case 'cancelled':
            return 'Cancelled';
        case 'PENDING':
        case 'pending':
            return 'Pending';
        case 'CLOSED_IMPORT':
        case 'closed_import':
            return 'Closed import';
        default:
            return '';
    }
};

export const mapLeadToListItem = (lead: any) => {
    return {
        primaryName: lead.name,
        avatarUrl: lead.avatarUrl,
        htmlUrl: lead.htmlUrl,
        htmlUrlPath: lead.htmlUrlPath,
        priority: lead.priority,
        fields: {
            name: {value: lead.id},
            number: {value: `${lead.number}`},
            owner: {
                value: lead.assignee
                    ? {
                          id: lead.assignee.id,
                          name: lead.assignee.name,
                          avatarUrl: lead.assignee.avatarUrl,
                          type: lead.assignee.type,
                          initials: lead.assignee.initials,
                      }
                    : undefined,
            },
            status: {value: {value: getLeadCardStatusString(lead.status)}},
            value: lead.value,
            contacts: {
                value: lead.contacts.primaryEdge
                    ? [
                          {
                              value: lead.contacts.primaryEdge.node,
                          },
                      ]
                    : null,
            },
            accounts: {
                value: lead.accounts.primaryEdge
                    ? [
                          {
                              value: lead.accounts.primaryEdge.node,
                          },
                      ]
                    : null,
            },
        },
        links: {
            entity: {
                id: lead.id,
            },
        },
    };
};
